// import { CSSResultGroup, LitElement } from 'lit';
import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
// import componentStyles from './outline-element.css.lit';

@customElement('outline-element')
export class OutlineElement extends LitElement {
  // static styles: CSSResultGroup = [componentStyles];
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-element': OutlineElement;
  }
}
